export const INTEREST_CONTENT_PERMISSION = {
  VIEW: 'INTEREST_CONTENT_VIEW',
  ADD: 'INTEREST_CONTENT_ADD',
  EDIT: 'INTEREST_CONTENT_EDIT',
  DEL: 'INTEREST_CONTENT_DEL',
};
